// Exact public editorial routes; generated from the marketing search-pages.json.
// Updated 2026-10-13: 56 public routes including calculators and comparisons.
export const PUBLIC_CONTENT_PATHS: readonly string[] = [
  "/learn/",
  "/instagram-crm/",
  "/instagram-lead-generation/",
  "/instagram-dm-automation/",
  "/instagram-growth-platform/",
  "/instagram-content-planner/",
  "/learn/how-to-grow-on-instagram/",
  "/learn/how-to-monetize-instagram/",
  "/learn/instagram-sales-pipeline/",
  "/free/",
  "/about/",
  "/learn/instagram-dm-templates/",
  "/learn/instagram-dm-follow-up/",
  "/learn/instagram-lead-qualification/",
  "/learn/instagram-lead-magnet/",
  "/learn/instagram-content-calendar/",
  "/learn/instagram-bio-for-leads/",
  "/learn/instagram-social-selling/",
  "/learn/instagram-audience-research/",
  "/learn/instagram-agency-workflow/",
  "/learn/instagram-leads-for-coaches/",
  "/learn/instagram-local-lead-generation/",
  "/learn/instagram-marketing-metrics/",
  "/learn/instagram-crm-setup/",
  "/learn/instagram-saved-reply-library/",
  "/learn/instagram-content-brief/",
  "/learn/instagram-audience-research-review/",
  "/learn/instagram-crm-tags/",
  "/learn/instagram-weekly-pipeline-review/",
  "/learn/instagram-pricing-replies/",
  "/learn/instagram-consultation-handoff/",
  "/learn/instagram-client-onboarding-checklist/",
  "/learn/instagram-client-reporting-template/",
  "/learn/how-to-choose-instagram-crm/",
  "/learn/gramfather-vs-spreadsheet/",
  "/learn/instagram-inbox-vs-crm/",
  "/learn/instagram-automation-buying-checklist/",
  "/learn/instagram-lead-funnel-calculator/",
  "/learn/first-1000-instagram-followers/",
  "/learn/instagram-reels-for-growth/",
  "/learn/instagram-seo/",
  "/learn/instagram-follower-growth-rate/",
  "/learn/instagram-growth-tools/",
  "/instagram-automation/",
  "/instagram-follower-tracker/",
  "/instagram-comment-automation/",
  "/learn/instagram-growth-workflow-tutorial/",
  "/learn/instagram-audience-research-tutorial/",
  "/learn/instagram-auto-dm-tutorial/",
  "/learn/instagram-crm-pipeline-tutorial/",
  "/learn/instagram-follower-tracker-tutorial/",
  "/learn/instagram-comment-automation-tutorial/",
  "/learn/instagram-post-scheduling-tutorial/",
  "/learn/instagram-analytics-tutorial/",
  "/learn/instagram-engagement-rate-calculator/",
  "/learn/gramfather-vs-manychat/",
  "/about/editorial-method/",
  "/learn/instagram-growth-workflow-example/"
];
